<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Recruitment Drive Test">
      <div class="row">
        <div class="col-md-6 form-group">
          Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = false"
          />
          <div v-if="nameEmpty" style="color: red">Name is required</div>
        </div>
        <div class="col-md-6 form-group">
          Image
          <b-form-file
            v-model="image"
            @change="(image = $event.target.files[0]), (imageEmpty = false)"
          ></b-form-file>
          <div v-if="imageEmpty" style="color: red">Image is required</div>
        </div>
        <div class="col-md-6 form-group">
          Description
          <input
            class="form-control"
            type="text"
            v-model="description"
            @focus="descriptionEmpty = false"
          />
          <div v-if="descriptionEmpty" style="color: red">
            Description is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Number Of Attempts
          <input class="form-control" type="text" value="1" readonly />
        </div>
        <div class="col-md-6 form-group">
          Negative Marks
          <input
            class="form-control"
            type="number"
            v-model="negativeMarks"
            @focus="negativeMarkEmpty = false"
          />
          <div v-if="negativeMarkEmpty" style="color: red">
            Negative mark is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Each Question Mark
          <input
            class="form-control"
            type="number"
            v-model="eachQuestionMark"
            @focus="eachQuestionMarkEmpty = false"
          />
          <div v-if="eachQuestionMarkEmpty" style="color: red">
            Each question mark is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Result Status
          <b-form-select
            v-model="resultStatus"
            @change="resultStatusEmpty = false"
          >
            <option
              v-for="(resultStatusOption, index) in resultStatusOptions"
              :key="index"
              :value="resultStatusOption.value"
            >
              {{ resultStatusOption.text }}
            </option>
          </b-form-select>
          <div v-if="resultStatusEmpty" style="color: red">
            Result status is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Start Date
          <b-form-datepicker
            v-model="startDate"
            @input="startDateEmpty = false"
          ></b-form-datepicker>
          <div v-if="startDateEmpty" style="color: red">
            Start date is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Start Time
          <b-form-timepicker
            v-model="startTime"
            @input="startTimeEmpty = false"
          ></b-form-timepicker>
          <div v-if="startTimeEmpty" style="color: red">
            Start time is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          End Date
          <b-form-datepicker
            v-model="endDate"
            @input="endDateEmpty = false"
          ></b-form-datepicker>
          <div v-if="endDateEmpty" style="color: red">End date is required</div>
        </div>
        <div class="col-md-6 form-group">
          End Time
          <b-form-timepicker
            v-model="endTime"
            @input="endTimeEmpty = false"
          ></b-form-timepicker>
          <div v-if="endTimeEmpty" style="color: red">End time is required</div>
        </div>
         <div class="col-md-6 form-group">
          <b-form-checkbox
            id="checkbox-1"
            v-model="has_coding"
            name="checkbox-1"
            value="1"
            unchecked-value="0"
          >
            Has Coding
          </b-form-checkbox>
        </div>
        <div class="col-md-6 form-group">
          Test Type
          <b-form-select
            v-model="testType"
            @change="testTypeEmpty = false"
            :disabled="finalArray.length > 0 || finalArray2.length > 0"
          >
            <option value="random">Random</option>
            <option value="default">Default</option>
          </b-form-select>
          <div v-if="testTypeEmpty" style="color: red">
            Test type is required
          </div>
        </div>

        <div class="col-md-12" v-if="durations.length > 0">
          Duration Details
          <b-table-simple
            responsive
            bordered
            striped
            table-class="table-vcenter"
          >
            <b-thead>
              <b-tr>
                <b-th class="text-center">S.NO</b-th>
                <b-th class="text-center">Parent Topic</b-th>
                <b-th class="text-center">Total Number Of Questions</b-th>
                <b-th class="text-center">Duration</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(duration, index) in durations" :key="index">
                <b-td class="text-center"> {{ index + 1 }} </b-td>
                <b-td class="text-center"> {{ duration.name }} </b-td>
                <b-td class="text-center">
                  {{
                    finalArray
                      .filter((ele) => ele.parentTopic.id == duration.id)
                      .map((ele) => ele.noOfQuestionsSelected || 0)
                      .reduce((a, b) => a + b)
                  }}
                </b-td>
                <b-td class="text-center"> {{ duration.duration }} </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <div class="col-md-12" v-if="finalArray != ''">
          Test Contents
          <b-table-simple
            responsive
            bordered
            striped
            table-class="table-vcenter"
          >
            <b-thead>
              <b-tr>
                <b-th class="text-center">S.NO</b-th>
                <b-th class="text-center">Parent Topic</b-th>
                <b-th class="text-center">Topic</b-th>
                <b-th class="text-center">Subtopic</b-th>
                <b-th class="text-center">Selected Questions</b-th>
                <b-th class="text-center">Total Number Of Questions</b-th>
                <b-th class="text-center">Action</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(final, index) in finalArray" :key="index">
                <b-td class="text-center"> {{ index + 1 }} </b-td>
                <b-td class="text-center"> {{ final.parentTopic.name }} </b-td>
                <b-td class="text-center"> {{ final.topic.name }} </b-td>
                <b-td class="text-center"> {{ final.subtopic.name }} </b-td>
                <b-td class="text-center">
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    v-b-modal.modal-2
                    @click="modal2Data = final.selectedQuestionsArray"
                  >
                    <i class="fa fa-fw fa-eye"></i>
                  </b-button>
                </b-td>
                <b-td class="text-center">
                  {{ final.noOfQuestionsSelected }}
                </b-td>
                <b-td class="text-center">
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    @click="removeRow(index, final.parentTopic)"
                  >
                    <i class="fa fa-fw fa-trash"></i>
                  </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <div class="form-group col-md-3" v-if="finalArray != ''">
          Overall Question Count
          <input
            class="form-control"
            type="text"
            :value="
              finalArray.length > 0
                ? finalArray
                    .map((ele) => ele.noOfQuestionsSelected || 0)
                    .reduce((a, b) => a + b)
                : 0
            "
            readonly
          />
        </div>

        <div
          :class="
            finalArray != ''
              ? 'col-md-9 mt-4 form-group'
              : 'col-md-12 mt-4 form-group'
          "
          v-if="testType == 'default' && testType != ''"
        >
          <b-button
            class="float-right"
            variant="success"
            v-b-modal.modal-1
            @click="getParentTopics()"
            >Add Questions</b-button
          >
        </div>

        <div class="col-md-12" v-if="durations2.length > 0">
          Duration Details
          <b-table-simple
            responsive
            bordered
            striped
            table-class="table-vcenter"
          >
            <b-thead>
              <b-tr>
                <b-th class="text-center">S.NO</b-th>
                <b-th class="text-center">Parent Topic</b-th>
                <b-th class="text-center">Duration</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(duration, index) in durations2" :key="index">
                <b-td class="text-center"> {{ index + 1 }} </b-td>
                <b-td class="text-center"> {{ duration.name }} </b-td>
                <b-td class="text-center"> {{ duration.duration2 }} </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <div class="col-md-12" v-if="testType == 'random' && finalArray2 != ''">
          Test Contents
          <b-table-simple
            responsive
            bordered
            striped
            table-class="table-vcenter"
          >
            <b-thead>
              <b-tr>
                <b-th class="text-center">S.NO</b-th>
                <b-th class="text-center">Parent Topic</b-th>
                <b-th class="text-center">Topic</b-th>
                <b-th class="text-center">Subtopic</b-th>
                <b-th class="text-center">Question Conut</b-th>
                <b-th class="text-center">Action</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(final, index) in finalArray2" :key="index">
                <b-td class="text-center"> {{ index + 1 }} </b-td>
                <b-td class="text-center"> {{ final.parentTopic.name }} </b-td>
                <b-td class="text-center">{{ final.topic.name }}</b-td>
                <b-td class="text-center"> {{ final.subtopic.name }} </b-td>
                <b-td class="text-center"> {{ final.questionCount }} </b-td>
                <b-td class="text-center">
                  <b-button
                    size="sm"
                    variant="alt-primary"
                    @click="removeRowRandom(index, final.parentTopic)"
                  >
                    <i class="fa fa-fw fa-trash"></i>
                  </b-button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <div class="form-group col-md-3" v-if="finalArray2 != ''">
          Overall Question Count
          <input
            class="form-control"
            type="text"
            :value="
              finalArray2.length > 0
                ? finalArray2
                    .map((ele) => parseInt(ele.questionCount) || 0)
                    .reduce((a, b) => a + b)
                : 0
            "
            readonly
          />
        </div>

        <div
          :class="
            finalArray2 != ''
              ? 'col-md-9 mt-4 form-group'
              : 'col-md-12 mt-4 form-group'
          "
          v-if="testType == 'random' && testType != ''"
        >
          <b-button
            class="float-right"
            variant="success"
            v-b-modal.modal-3
            @click="getParentTopics()"
            >Add Questions</b-button
          >
        </div>

        <b-modal
          id="modal-1"
          title="Add Questions"
          size="xl"
          ref="modalone"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
          @close="closeModal1()"
        >
          <div class="row">
            <div class="col-md-6 form-group">
              Parent Topic
              <b-form-select
                v-model="parentTopic"
                @change="getTopics()"
                required
              >
                <option
                  v-for="(parentTopic, index) in parentTopics"
                  :key="index"
                  :value="parentTopic.id"
                >
                  {{ parentTopic.name }}
                </option>
              </b-form-select>
              <div v-if="parentTopicEmpty" style="color: red">
                Parent topic is required
              </div>
            </div>

            <div class="col-md-6 form-group" v-if="parentTopic != ''">
              Topic
              <b-form-select v-model="topic" @change="getSubtopics()" required>
                <option
                  v-for="(topic, index) in topics"
                  :key="index"
                  :value="topic.id"
                >
                  {{ topic.name }}
                </option>
              </b-form-select>
              <div v-if="topicEmpty" style="color: red">Topic is required</div>
            </div>

            <div class="col-md-6 form-group" v-if="topic != ''">
              Sub Topic
              <b-form-select
                v-model="subtopic"
                @change="getQuestions()"
                required
              >
                <option
                  v-for="(subtopic, index) in subtopics"
                  :key="index"
                  :value="subtopic.id"
                >
                  {{ subtopic.name }}
                </option>
              </b-form-select>
              <div v-if="subtopicEmpty" style="color: red">
                Subtopic is required
              </div>
            </div>

            <div
              class="col-md-6 form-group"
              v-if="
                subtopic != '' &&
                (finalArray.findIndex(
                  (element) => element.parentTopic.id == parentTopic
                ) >= 0
                  ? false
                  : true)
              "
            >
              Duration (mins)
              <input
                type="number"
                class="form-control"
                v-model="duration"
                @focus="durationEmpty = false"
              />
              <div v-if="durationEmpty" style="color: red">
                Duration is required
              </div>
            </div>

            <div class="col-md-12" v-if="questionData != '' && subtopic != ''">
              <dl class="float-right">
                <dt class="green"></dt>
                <dd>Fillups</dd>

                <dt class="blue"></dt>
                <dd>Group</dd>

                <dt class="grey"></dt>
                <dd>MCQ</dd>
                 <dt class="yellow"></dt>
                <dd>Coding</dd>
              </dl>
            </div>

            <div class="col-md-12 form-group" v-if="subtopic != ''">
              <h3 class="block-title" v-if="questionData != ''">
                Select Questions for test
              </h3>

              <b-list-group
                class="list-group"
                v-for="(question, index) in questionData"
                :key="index"
              >
                <b-list-group-item
                  :class="
                    questionData[index].question_type == 'fill_in_blank'
                      ? 'border-warning mb-1'
                      : questionData[index].question_type == 'group'
                      ? 'border-primary mb-1' : questionData[index].question_type == 'coding' ? 'border-success mb-1'
                      : 'border-dark mb-1'
                  "
                >
                <b-button
                    size="sm"
                    class="float-right"
                    v-on:click="addQuestions(question)"
                    :variant="
                      questionData[index].question_type == 'group'
                        ? selectedQuestion.includes(question)
                          ? 'danger'
                          : 'success'
                        : selectedQuestion.includes(question)
                        ? 'danger'
                        : 'success'
                    "
                    ><i
                      :class="
                        questionData[index].question_type == 'group'
                          ? selectedQuestion.includes(question)
                            ? 'fa fa-fw fa-times'
                            : 'fa fa-fw fa-check'
                          : selectedQuestion.includes(question)
                          ? 'fa fa-fw fa-times'
                          : 'fa fa-fw fa-check'
                      "
                    ></i
                  ></b-button>
                  <p v-html="questionData[index].question"></p>
                </b-list-group-item>
              </b-list-group>
            </div>

            <div class="col-md-12" v-if="selectedQuestion != ''">
              <b-button
                variant="success"
                class="float-right ml-2 mt-4"
                @click="insertRow()"
                >Insert</b-button
              >
              <b-button
                variant="danger"
                class="float-right mt-4"
                @click="cancelModal1()"
                >Cancel</b-button
              >
              <div class="form-group">
                No.Of Questions Selected
                <input
                  type="number"
                  class="form-control col-md-3"
                  v-model="noOfQuestionsSelected"
                  readonly
                />
              </div>
            </div>
          </div>
        </b-modal>

        <b-modal
          id="modal-2"
          ref="modaltwo"
          title="Selected Questions"
          ok-variant="success"
          no-close-on-esc
          no-close-on-backdrop
          cancel-variant="danger"
          size="xl"
          @ok="modal2Data = []"
          @cancel="modal2Data = []"
          @close="modal2Data = []"
        >
          <div class="row">
            <div class="col-md-12">
              <dl class="float-right">
                <dt class="green"></dt>
                <dd>Fillups</dd>

                <dt class="blue"></dt>
                <dd>Group</dd>

                <dt class="grey"></dt>
                <dd>MCQ</dd>
                  <dt class="yellow"></dt>
                <dd>Coding</dd>
              </dl>
            </div>

            <div class="col-md-12 form-group">
              <b-list-group v-for="(data, index) in modal2Data" :key="index">
                {{ mathRender() }}
                <b-list-group-item
                  v-html="`${data.question}`"
                  :class="
                    data.question_type == 'fill_in_blank'
                      ? 'border-warning mb-1'
                      : data.question_type == 'group'
                      ? 'border-primary mb-1' : data.question_type == 'coding' ? 'border-success mb-1'
                      : 'border-dark mb-1'
                  "
                  ></b-list-group-item
                >
              </b-list-group>
            </div>
          </div>
        </b-modal>
        <!-- Random Modal -->
        <b-modal
          id="modal-3"
          title="Add Questions"
          size="xl"
          ref="modalthree"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
          @close="closeRandom()"
        >
          <div class="row">
            <div class="col-md-6 form-group">
              Parent Topic
              <b-form-select
                v-model="parentTopic"
                @change="getTopics()"
                required
              >
                <option
                  v-for="(parentTopic, index) in parentTopics"
                  :key="index"
                  :value="parentTopic.id"
                >
                  {{ parentTopic.name }}
                </option>
              </b-form-select>
              <div v-if="parentTopicEmpty" style="color: red">
                Parent topic is required
              </div>
            </div>

            <div class="col-md-6 form-group" v-if="parentTopic != ''">
              Topic
              <b-form-select v-model="topic" @change="getSubtopics()" required>
                <option
                  v-for="(topic, index) in topics"
                  :key="index"
                  :value="topic.id"
                >
                  {{ topic.name }}
                </option>
              </b-form-select>
              <div v-if="topicEmpty" style="color: red">Topic is required</div>
            </div>

            <div class="col-md-6 form-group" v-if="topic != ''">
              Sub Topic
              <b-form-select v-model="subtopic" @change="getInfo()" required>
                <option
                  v-for="(subtopic, index) in subtopics"
                  :key="index"
                  :value="subtopic.id"
                >
                  {{ subtopic.name }}
                </option>
              </b-form-select>
              <div v-if="subtopicEmpty" style="color: red">
                Subtopic is required
              </div>
            </div>

            <div v-if="subtopic != ''" class="col-md-6 form-group">
              Question Availability Info
              <div
                class="alert alert-info mb-0"
                role="alert"
                style="padding: 6px 12px"
              >
                {{ info }}
              </div>
            </div>

            <div class="col-md-6 form-group" v-if="subtopic != ''">
              Question Count
              <input
                type="number"
                @input="enableAlert()"
                v-model="questionCount"
                class="form-control"
                @focus="(questionCountEmpty = false), (infoAlert = false)"
              />
              <div v-if="questionCountEmpty" style="color: red">
                Question count is required
              </div>
              <div v-if="infoAlert" style="color: red">
                Question count should not be greater than
                {{
                  Number(this.info.split(" ")[1]) +
                  Number(this.info.split(" ")[3])
                }}
              </div>
            </div>

            <div
              class="col-md-6 form-group"
              v-if="
                subtopic != '' &&
                (finalArray2.findIndex(
                  (element) => element.parentTopic.id == parentTopic
                ) >= 0
                  ? false
                  : true)
              "
            >
              Duration (mins)
              <input
                type="number"
                class="form-control"
                v-model="duration2"
                @focus="durationEmpty = false"
              />
              <div v-if="durationEmpty" style="color: red">
                Duration is required
              </div>
            </div>

            <div class="col-md-12" v-if="questionCount != ''">
              <b-button
                variant="success"
                class="float-right ml-2"
                @click="insertRowRandom()"
                >Insert</b-button
              >
              <b-button
                variant="danger"
                class="float-right"
                @click="cancelRandom()"
                >Cancel</b-button
              >
            </div>
          </div>
        </b-modal>

        <div
          class="text-center form-group"
          style="width: 100%"
          v-if="finalArray != '' && testType == 'default'"
        >
          <b-button variant="success" @click="save()">Save</b-button>
        </div>

        <div
          class="text-center form-group"
          style="width: 100%"
          v-if="finalArray2 != '' && testType == 'random'"
        >
          <b-button variant="success" @click="saveRandom()">Save</b-button>
        </div>
      </div>
      <!-- Loader -->
      <b-overlay
        :show="loader"
        no-wrap
        blur="2px"
        opacity="0.60"
        class="position-fixed"
      >
        <template #overlay>
          <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
        </template>
      </b-overlay>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  methods: {
    mathRender() {
      if ("MathJax" in window) {
        this.$nextTick(async function () {
          await window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
            console.log("done")
          );
        });
      }
    },
    enableAlert() {
      if (
        Number(this.questionCount) >
        Number(this.info.split(" ")[1]) + Number(this.info.split(" ")[3])
      ) {
        this.infoAlert = true;
      }
    },

    removeRowRandom(index, parentTopic) {
      console.log(parentTopic);
      this.finalArray2.splice(index, 1);
      var hasParentTopic = this.finalArray2.filter(
        (ele) => ele.parentTopic.id == parentTopic.id
      );
      if (!hasParentTopic.length > 0) {
        let index = this.durations2.findIndex(
          (ele) => ele.id == parentTopic.id
        );
        console.log(index);
        this.durations2.splice(index, 1);
        hasParentTopic = true;
      }
    },

    async saveRandom() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
      if (this.image == "") {
        this.imageEmpty = true;
        return;
      }
      if (this.description == "") {
        this.descriptionEmpty = true;
        return;
      }
      if (this.negativeMarks == "") {
        this.negativeMarkEmpty = true;
        return;
      }
      if (this.eachQuestionMark == "") {
        this.eachQuestionMarkEmpty = true;
        return;
      }
      if (this.resultStatus == "") {
        this.resultStatusEmpty = true;
        return;
      }
      if (this.startDate == "") {
        this.startDateEmpty = true;
        return;
      }
      if (this.startTime == "") {
        this.startTimeEmpty = true;
        return;
      }
      if (this.endDate == "") {
        this.endDateEmpty = true;
        return;
      }
      if (this.endTime == "") {
        this.endTimeEmpty = true;
        return;
      }
      if (this.testType == "") {
        this.testTypeEmpty = true;
        return;
      }
      this.loader = true;
      var temp_data = [];
      this.finalArray2.forEach((ele) => {
        let {
          parentTopic = {},
          topic = {},
          subtopic = {},
          questionCount = 0,
        } = ele;
        let parentIndex = temp_data.findIndex(
          (temp_ele) => temp_ele.topic_id == parentTopic.id
        );
        if (parentIndex >= 0) {
          temp_data[parentIndex].no_of_questions =
            temp_data[parentIndex].no_of_questions +
            parseInt(ele.questionCount);

          let topicIndex = temp_data[parentIndex].topics.findIndex(
            (temp_ele) => temp_ele.topic_id == topic.id
          );
          if (topicIndex >= 0) {
            let subTopicIndex = temp_data[parentIndex].topics.findIndex(
              (temp_ele) => temp_ele.topic_id == topic.id
            );
            if (subTopicIndex >= 0) {
              let temp_sub_topics =
                temp_data[parentIndex].topics[topicIndex].topics;
              temp_sub_topics.push({
                topic_id: subtopic.id,
                questions: questionCount,
              });
              temp_data[parentIndex].topics[topicIndex].topics =
                temp_sub_topics;
            } else {
              let temp_sub_topics =
                temp_data[parentIndex].topics[topicIndex].topics;
              temp_sub_topics.push({
                topic_id: subtopic.id,
                questions: questionCount,
              });
              temp_data[parentIndex].topics[topicIndex].topics =
                temp_sub_topics;
            }
          } else {
            let temp_topics = temp_data[parentIndex].topics;
            temp_topics.push({
              topic_id: topic.id,
              topics: [
                {
                  topic_id: subtopic.id,
                  questions: questionCount,
                },
              ],
            });
            temp_data[parentIndex].topics = temp_topics;
          }
        } else {
          temp_data.push({
            topic_id: parentTopic.id,
            no_of_questions: parseInt(ele.questionCount),
            duration: this.durations2.find((ele) => ele.id == parentTopic.id)
              .duration2,
            topics: [
              {
                topic_id: topic.id,
                topics: [
                  {
                    topic_id: subtopic.id,
                    questions: questionCount,
                  },
                ],
              },
            ],
          });
        }
      });
      console.log(temp_data);
      const formdata = new FormData();
      formdata.append("name", this.name);
      formdata.append("image", this.image);
      formdata.append("type", "ongoing");
      formdata.append("description", this.description);
      formdata.append("negative_mark", this.negativeMarks);
      formdata.append("each_question_mark", this.eachQuestionMark);
      formdata.append("result_status", this.resultStatus);
      formdata.append("start_date", this.startDate);
      formdata.append("start_time", this.startTime);
      formdata.append("end_date", this.endDate);
      formdata.append("end_time", this.endTime);
      formdata.append("test_type", this.testType);
      formdata.append("has_coding", this.has_coding);

      for (var i = 0; i < temp_data.length; i++) {
        formdata.append("topics[" + i + "][topic_id]", temp_data[i].topic_id);
        formdata.append("topics[" + i + "][duration]", temp_data[i].duration);
        formdata.append(
          "topics[" + i + "][no_of_questions]",
          temp_data[i].no_of_questions
        );
        for (var j = 0; j < temp_data[i].topics.length; j++) {
          formdata.append(
            "topics[" + i + "][topics][" + j + "][topic_id]",
            temp_data[i].topics[j].topic_id
          );
          for (var k = 0; k < temp_data[i].topics[j].topics.length; k++) {
            formdata.append(
              "topics[" +
                i +
                "][topics][" +
                j +
                "][topics][" +
                k +
                "][topic_id]",
              temp_data[i].topics[j].topics[k].topic_id
            );
            formdata.append(
              "topics[" +
                i +
                "][topics][" +
                j +
                "][topics][" +
                k +
                "][questions]",
              temp_data[i].topics[j].topics[k].questions
            );
            console.log(
              "questions",
              temp_data[i].topics[j].topics[k].questions
            );
          }
        }
      }

      await axios
        .post(
          `${this.$store.getters.baseUrl}/recruitment-drives/add`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal(
              "Success",
              "Ongoing Recruitment drive test added successfully",
              "success"
            );
            this.$router.push({ name: "Recruitment Drive Test" });
            (this.name = ""),
              (this.image = []),
              (this.description = ""),
              (this.negativeMarks = ""),
              (this.eachQuestionMark = ""),
              (this.resultStatus = ""),
              (this.startDate = ""),
              (this.startTime = ""),
              (this.endDate = ""),
              (this.endTime = ""),
              (this.testType = ""),
              (this.durations2 = []),
              (this.finalArray2 = []);
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    insertRowRandom() {
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }
      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }
      if (this.subtopic == "") {
        this.subtopicEmpty = true;
        return;
      }
      if (this.questionCount == "") {
        this.questionCountEmpty = true;
        return;
      }
      if (
        this.finalArray2.findIndex(
          (element) => element.parentTopic.id == this.parentTopic
        ) >= 0
          ? false
          : true
      ) {
        if (this.duration2 == "") {
          this.durationEmpty = true;
          return;
        }
      }
      this.durationEmpty = false;

      var selectedParentTopic = "";
      for (var i = 0; i < this.parentTopics.length; i++) {
        if (this.parentTopics[i].id == this.parentTopic) {
          selectedParentTopic = this.parentTopics[i];
        }
      }
      var selectedTopic = "";
      for (var j = 0; j < this.topics.length; j++) {
        if (this.topics[j].id == this.topic) {
          selectedTopic = this.topics[j];
        }
      }
      var selectedSubtopic = "";
      for (var k = 0; k < this.subtopics.length; k++) {
        if (this.subtopics[k].id == this.subtopic) {
          selectedSubtopic = this.subtopics[k];
        }
      }

      this.finalArray2.push({
        parentTopic: selectedParentTopic,
        topic: selectedTopic,
        subtopic: selectedSubtopic,
        questionCount: this.questionCount,
      });

      if (this.duration2 != "") {
        var data = this.parentTopics.find((ele) => ele.id == this.parentTopic);
        this.durations2.push({
          id: data.id,
          name: data.name,
          duration2: this.duration2,
        });
      }

      this.parentTopic = "";
      (this.topic = ""),
        (this.subtopic = ""),
        (this.questionCount = ""),
        (this.duration2 = "");
      this.parentTopics = [];
      this.topics = [];
      this.subtopics = [];
      this.$refs.modalthree.hide();
    },
    cancelRandom() {
      this.parentTopic = "";
      (this.topic = ""),
        (this.subtopic = ""),
        (this.questionCount = ""),
        (this.duration2 = "");
      this.parentTopics = [];
      this.topics = [];
      this.subtopics = [];
      (this.parentTopicEmpty = false),
        (this.topicEmpty = false),
        (this.subtopicEmpty = false),
        (this.questionCountEmpty = false),
        (this.durationEmpty = false),
        (this.infoAlert = false),
        this.$refs.modalthree.hide();
    },
    closeRandom() {
      this.parentTopic = "";
      (this.topic = ""),
        (this.subtopic = ""),
        (this.questionCount = ""),
        (this.duration2 = "");
      this.parentTopics = [];
      this.topics = [];
      this.subtopics = [];
      (this.parentTopicEmpty = false),
        (this.topicEmpty = false),
        (this.subtopicEmpty = false),
        (this.questionCountEmpty = false),
        (this.durationEmpty = false),
        (this.infoAlert = false);
    },
    closeModal1() {
      (this.parentTopic = ""),
        (this.topic = ""),
        (this.subtopic = ""),
        (this.questionData = []),
        (this.selectedQuestion = []);
      (this.duration = ""), (this.parentTopics = []);
      this.topics = [];
      this.noOfQuestionsSelected = 0;
      this.subtopics = [];
      (this.parentTopicEmpty = false),
        (this.topicEmpty = false),
        (this.subtopicEmpty = false),
        (this.durationEmpty = false);
    },
    removeRow(index, parentTopic) {
      console.log(parentTopic);
      this.finalArray.splice(index, 1);
      var hasParentTopic = this.finalArray.filter(
        (ele) => ele.parentTopic.id == parentTopic.id
      );
      if (!hasParentTopic.length > 0) {
        let index = this.durations.findIndex((ele) => ele.id == parentTopic.id);
        console.log(index);
        this.durations.splice(index, 1);
        hasParentTopic = true;
      }
    },
    insertRow() {
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }
      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }
      if (this.subtopic == "") {
        this.subtopicEmpty = true;
        return;
      }
      if (
        this.finalArray.findIndex(
          (element) => element.parentTopic.id == this.parentTopic
        ) >= 0
          ? false
          : true
      ) {
        if (this.duration == "") {
          this.durationEmpty = true;
          return;
        }
      }
      this.durationEmpty = false;
      var selectedParentTopic = "";
      for (var i = 0; i < this.parentTopics.length; i++) {
        if (this.parentTopics[i].id == this.parentTopic) {
          selectedParentTopic = this.parentTopics[i];
        }
      }
      var selectedTopic = "";
      for (var j = 0; j < this.topics.length; j++) {
        if (this.topics[j].id == this.topic) {
          selectedTopic = this.topics[j];
        }
      }
      var selectedSubtopic = "";
      for (var k = 0; k < this.subtopics.length; k++) {
        if (this.subtopics[k].id == this.subtopic) {
          selectedSubtopic = this.subtopics[k];
        }
      }

      this.finalArray.push({
        parentTopic: selectedParentTopic,
        topic: selectedTopic,
        subtopic: selectedSubtopic,
        noOfQuestionsSelected: this.noOfQuestionsSelected,
        selectedQuestionsArray: this.selectedQuestion,
      });

      if (this.duration != "") {
        var data = this.parentTopics.find((ele) => ele.id == this.parentTopic);
        this.durations.push({
          id: data.id,
          name: data.name,
          duration: this.duration,
        });
      }

      this.parentTopic = "";
      this.topic = "";
      this.subtopic = "";
      this.questionData = [];
      this.selectedQuestion = [];
      this.duration = "";
      this.parentTopics = [];
      this.topics = [];
      this.subtopics = [];
      this.noOfQuestionsSelected = 0;
      this.$refs.modalone.hide();
    },
    cancelModal1() {
      (this.parentTopic = ""),
        (this.topic = ""),
        (this.subtopic = ""),
        (this.questionData = []),
        (this.selectedQuestion = []);
      this.duration = "";
      this.parentTopics = [];
      this.topics = [];
      this.subtopics = [];
      this.noOfQuestionsSelected = 0;
      (this.parentTopicEmpty = false),
        (this.topicEmpty = false),
        (this.subtopicEmpty = false),
        (this.durationEmpty = false);
      this.$refs.modalone.hide();
    },
    addQuestions(question) {
      if (this.selectedQuestion.includes(question)) {
        let index = this.selectedQuestion.indexOf(question);
        this.selectedQuestion.splice(index, 1);
        if (question.question_type == "group") {
          this.noOfQuestionsSelected =
            this.noOfQuestionsSelected - question.subquestions.length;
        } else {
          this.noOfQuestionsSelected = this.noOfQuestionsSelected - 1;
        }
      } else {
        this.selectedQuestion.push(question);
        if (question.question_type == "group") {
          this.noOfQuestionsSelected =
            this.noOfQuestionsSelected + question.subquestions.length;
        } else {
          this.noOfQuestionsSelected = this.noOfQuestionsSelected + 1;
        }
      }
      console.log(this.selectedQuestion);
    },

    async getParentTopics() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.parentTopics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getTopics() {
      this.parentTopicEmpty = false;
      this.subtopic = "";
      this.topic = "";
      this.duration = "";
      this.duration2 = "";
      this.selectedQuestion = [];
      this.noOfQuestionsSelected = 0;
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.parentTopic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.topics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getSubtopics() {
      this.topicEmpty = false;
      this.subtopic = "";
      this.selectedQuestion = [];
      this.duration = "";
      this.duration2 = "";
      this.noOfQuestionsSelected = 0;
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.topic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.subtopics =
              this.testType == "default"
                ? response.data.topics.filter((sub_ele) =>
                    this.finalArray.findIndex(
                      (element) => element.subtopic.id == sub_ele.id
                    ) >= 0
                      ? false
                      : true
                  )
                : response.data.topics.filter((sub_ele) =>
                    this.finalArray2.findIndex(
                      (element) => element.subtopic.id == sub_ele.id
                    ) >= 0
                      ? false
                      : true
                  );
            console.log(this.subtopics);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getInfo() {
      this.subtopicEmpty = false;
      if (this.testType == "random") {
        console.log(this.subtopic);
        await axios
          .get(
            `${this.$store.getters.baseUrl}/recruitment-drives/question-count/${this.subtopic}`,
            {
              headers: {
                Authorization: `Bearer ${this.$store.getters.token}`,
              },
            }
          )
          .then((response) => {
            console.log(response);
            if (response.data.status == "success") {
              this.info = `Fillups: ${response.data.number_of_fill_in_blank} MCQ: ${response.data.number_of_objective} Group Question: ${response.data.number_of_group} Coding: ${response.data.number_of_coding}`;
            }
          });
      }
    },

    async getQuestions() {
      this.subtopicEmpty = false;
      this.selectedQuestion = [];
      this.noOfQuestionsSelected = 0;
      await axios
        .get(
          `${this.$store.getters.baseUrl}/mock-tests/question-load/${this.subtopic}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.questionData = response.data.questions;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      if ("MathJax" in window) {
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
          console.log("done")
        );
      }
    },
    async save() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
      if (this.image == "") {
        this.imageEmpty = true;
        return;
      }
      if (this.description == "") {
        this.descriptionEmpty = true;
        return;
      }
      if (this.negativeMarks == "") {
        this.negativeMarkEmpty = true;
        return;
      }
      if (this.eachQuestionMark == "") {
        this.eachQuestionMarkEmpty = true;
        return;
      }
      if (this.resultStatus == "") {
        this.resultStatusEmpty = true;
        return;
      }
      if (this.startDate == "") {
        this.startDateEmpty = true;
        return;
      }
      if (this.startTime == "") {
        this.startTimeEmpty = true;
        return;
      }
      if (this.endDate == "") {
        this.endDateEmpty = true;
        return;
      }
      if (this.endTime == "") {
        this.endTimeEmpty = true;
        return;
      }
      if (this.testType == "") {
        this.testTypeEmpty = true;
        return;
      }
      this.loader = true;
      var temp_data = [];
      this.finalArray.forEach((ele) => {
        let {
          parentTopic = {},
          topic = {},
          subtopic = {},
          selectedQuestionsArray = [],
        } = ele;
        let parentIndex = temp_data.findIndex(
          (temp_ele) => temp_ele.topic_id == parentTopic.id
        );
        if (parentIndex >= 0) {
          temp_data[parentIndex].no_of_questions = this.finalArray
            .filter((ele) => ele.parentTopic.id == parentTopic.id)
            .map((ele) => ele.noOfQuestionsSelected || 0)
            .reduce((a, b) => a + b);

          let topicIndex = temp_data[parentIndex].topics.findIndex(
            (temp_ele) => temp_ele.topic_id == topic.id
          );
          if (topicIndex >= 0) {
            let subTopicIndex = temp_data[parentIndex].topics.findIndex(
              (temp_ele) => temp_ele.topic_id == topic.id
            );
            if (subTopicIndex >= 0) {
              let temp_sub_topics =
                temp_data[parentIndex].topics[topicIndex].topics;
              temp_sub_topics.push({
                topic_id: subtopic.id,
                questions: selectedQuestionsArray.map((qstn) =>
                  qstn.question_type == "group"
                    ? qstn.subquestions.map((sub) => sub.id)
                    : qstn.id
                ),
              });
              temp_data[parentIndex].topics[topicIndex].topics =
                temp_sub_topics;
            } else {
              let temp_sub_topics =
                temp_data[parentIndex].topics[topicIndex].topics;
              temp_sub_topics.push({
                topic_id: subtopic.id,
                questions: selectedQuestionsArray.map((qstn) =>
                  qstn.question_type == "group"
                    ? qstn.subquestions.map((sub) => sub.id)
                    : qstn.id
                ),
              });
              temp_data[parentIndex].topics[topicIndex].topics =
                temp_sub_topics;
            }
          } else {
            let temp_topics = temp_data[parentIndex].topics;
            temp_topics.push({
              topic_id: topic.id,
              topics: [
                {
                  topic_id: subtopic.id,
                  questions: selectedQuestionsArray.map((qstn) =>
                    qstn.question_type == "group"
                      ? qstn.subquestions.map((sub) => sub.id)
                      : qstn.id
                  ),
                },
              ],
            });
            temp_data[parentIndex].topics = temp_topics;
          }
        } else {
          temp_data.push({
            topic_id: parentTopic.id,
            no_of_questions: this.finalArray
              .filter((ele) => ele.parentTopic.id == parentTopic.id)
              .map((ele) => ele.noOfQuestionsSelected || 0)
              .reduce((a, b) => a + b),
            duration: this.durations.find((ele) => ele.id == parentTopic.id)
              .duration,
            topics: [
              {
                topic_id: topic.id,
                topics: [
                  {
                    topic_id: subtopic.id,
                    questions: selectedQuestionsArray.map((qstn) =>
                      qstn.question_type == "group"
                        ? qstn.subquestions.map((sub) => sub.id)
                        : qstn.id
                    ),
                  },
                ],
              },
            ],
          });
        }
      });
      console.log(temp_data);
      console.log('something');

      const formdata = new FormData();
      formdata.append("name", this.name);
      formdata.append("image", this.image);
      formdata.append("type", "ongoing");
      formdata.append("description", this.description);
      formdata.append("negative_mark", this.negativeMarks);
      formdata.append("each_question_mark", this.eachQuestionMark);
      formdata.append("result_status", this.resultStatus);
      formdata.append("start_date", this.startDate);
      formdata.append("start_time", this.startTime);
      formdata.append("end_date", this.endDate);
      formdata.append("end_time", this.endTime);
      formdata.append("has_coding", this.has_coding);
      formdata.append("test_type", this.testType);
      for (var i = 0; i < temp_data.length; i++) {
        formdata.append("topics[" + i + "][topic_id]", temp_data[i].topic_id);
        formdata.append("topics[" + i + "][duration]", temp_data[i].duration);
        formdata.append(
          "topics[" + i + "][no_of_questions]",
          temp_data[i].no_of_questions
        );
        for (var j = 0; j < temp_data[i].topics.length; j++) {
          formdata.append(
            "topics[" + i + "][topics][" + j + "][topic_id]",
            temp_data[i].topics[j].topic_id
          );
          for (var k = 0; k < temp_data[i].topics[j].topics.length; k++) {
            formdata.append(
              "topics[" +
                i +
                "][topics][" +
                j +
                "][topics][" +
                k +
                "][topic_id]",
              temp_data[i].topics[j].topics[k].topic_id
            );
            formdata.append(
              "topics[" +
                i +
                "][topics][" +
                j +
                "][topics][" +
                k +
                "][questions]",
              temp_data[i].topics[j].topics[k].questions
            );
            console.log(
              "questions",
              temp_data[i].topics[j].topics[k].questions
            );
          }
        }
      }

      await axios
        .post(
          `${this.$store.getters.baseUrl}/recruitment-drives/add`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal(
              "Success",
              "Ongoing Recruitment drive test added successfully",
              "success"
            );
            this.$router.push({ name: "Recruitment Drive Test" });
            (this.name = ""),
              (this.image = []),
              (this.description = ""),
              (this.negativeMarks = ""),
              (this.eachQuestionMark = ""),
              (this.resultStatus = ""),
              (this.startDate = ""),
              (this.startTime = ""),
              (this.endDate = ""),
              (this.endTime = ""),
              (this.testType = ""),
              (this.durations = []),
              (this.finalArray = []);
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
  data() {
    return {
      loader: false,
      infoAlert: false,
      questionCountEmpty: false,
      testTypeEmpty: false,
      endTimeEmpty: false,
      endDateEmpty: false,
      startTimeEmpty: false,
      startDateEmpty: false,
      resultStatusEmpty: false,
      eachQuestionMarkEmpty: false,
      negativeMarkEmpty: false,
      descriptionEmpty: false,
      imageEmpty: false,
      nameEmpty: false,
      durations2: [],
      info: "",
      finalArray2: [],
      duration2: "",
      questionCount: "",
      durationEmpty: false,
      noOfQuestionsSelected: 0,
      durations: [],
      duration: "",
      parentTopicEmpty: false,
      topicEmpty: false,
      subtopicEmpty: false,
      eachQuestionMark: "",
      negativeMarks: "",
      description: "",
      image: [],
      name: "",
      testType: "",
      startDate: "",
      startTime: "",
      endDate: "",
      endTime: "",
      resultStatus: "",
      resultStatusOptions: [
        { text: "No Result", value: 3 },
        { text: "Result", value: 1 },
        { text: "Result & Solution", value: 2 },
      ],
      parentTopic: "",
      parentTopics: [],
      topic: "",
      topics: [],
      subtopic: "",
      subtopics: [],
      questionData: [],
      selectedQuestion: [],
      finalArray: [],
      modal2Data: [],
       has_coding: 0,
    };
  },
};
</script>
<style scoped>
dl dt {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
dl dd {
  display: inline-block;
  margin: 0px 10px;
  padding-bottom: 0;
  vertical-align: middle;
}
dl dt.green {
  background: #e5ae67;
}
dl dt.grey {
  background: #343a40;
}
dl dt.blue {
  background: #5179d6;
}
dl dt.yellow {
  background: #30c78d ;
}
</style>